exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NewKeyValue___34r7B {\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n}\n\n.EditableName___2W--L {\n  margin-left: 1rem;\n}\n\n.EditableValue___16Q0K {\n  min-width: 1rem;\n}\n", ""]);

// exports
exports.locals = {
	"NewKeyValue": "NewKeyValue___34r7B",
	"EditableName": "EditableName___2W--L",
	"EditableValue": "EditableValue___16Q0K"
};